import { FC, useState } from 'react'
import { Formik } from 'formik';
import { Form } from 'react-router-dom';
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

import RadioOption from '../../../../../../../common/RadioOption';
import CustomButton from '../../../../../../../common/CustomButton';
import HomeIcon from '../../../../../../../assets/icons/Home.png';
import CardIcon from '../../../../../../../assets/icons/card.png';
import CheckMarkIcon from '../../../../../../../assets/icons/Checkmark, Done, Check.png';
import DiamondIcon from '../../../../../../../assets/icons/diamond.png';
import InformationIcon from '../../../../../../../assets/icons/Info, Infornation.png';
import { useAppDispatch, useAppSelector } from '../../../../../../../hooks/redux';
import { useUpdateUserAdditionalInfoMutation } from '../../../../../../../store/services/customizeOptionsApi';
import { setUserInfo } from '../../../../../../../store/slices/userSlice';

import styles from './BudgetPreferences.module.scss';

type FormikValues = {
  budget?: string;
}

type BudgetPreferencesProps = {
  closeModal: () => void;
}

const BudgetPreferences: FC<BudgetPreferencesProps> = ({ closeModal }) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(state => state.user);
  const [ updateUserAdditionalInfo, {isSuccess} ] = useUpdateUserAdditionalInfoMutation();

  const [resErrors, setResErrors] = useState<{attr: string | null, code: string, detail: string}[] | null>(null);

  const initialValues = {
    budget: user.budget_preference,
  };

  const handleSubmit = async (values: FormikValues) => {
    const payload = {
      budget_preference: values.budget,
    };

    try {
      await updateUserAdditionalInfo(payload);
      dispatch(setUserInfo(payload));
      setResErrors(null);
      closeModal();
    } catch (error) {
      console.error("Error updating user info:", error);
      setResErrors((error as any)?.data?.errors || null);
    }
  };

  const formikValidate = (values: FormikValues) => {
    const errors: FormikValues = {};

    return errors;
  }

  return (
    <Box className={styles.BudgetPreferences}>
      <Formik
        initialValues={initialValues}
        validate={formikValidate}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, handleSubmit, isSubmitting }) => (
          <Form className={styles.BudgetPreferencesForm} onSubmit={handleSubmit}>
            <FormControl component="fieldset" className={styles.radioGroupWrapper}>
              <Typography variant='h5Bold'className={styles.stepTitle}>Let's personalize your AI assistant</Typography>
              <Typography variant='h10' className={styles.stepSubtitle}>Budget Preferences</Typography>
              <RadioGroup name="budget" className={styles.radioGroup} value={values.budget} onChange={handleChange}>
                {[
                  { value: "Economy", name: "Economy", icon: HomeIcon },
                  { value: "Mid-range", name: "Mid-Range", icon: CardIcon },
                  { value: "Luxury", name: "Luxury", icon: DiamondIcon },
                  { value: "Doesn't matter", name: "Doesn't Matter", icon: CheckMarkIcon },
                ].map((val) => (
                  <FormControlLabel
                    key={val.value}
                    value={val.value}
                    control={<Radio sx={{ display: "none" }} />}
                    label={<RadioOption value={val.value} icon={val.icon} label={val.name.replace("_", " ")}
                      selected={values.budget === val.value}
                    />}
                  />
                ))}
              </RadioGroup>
            </FormControl>

            <Box className={styles.additionalInfo}>
              <Typography variant='h11' className={styles.additionalInfoText}>To get badges, fill in all the questions</Typography>
              <img src={InformationIcon} className={styles.additionalInfoImg} alt='info' />
            </Box>

            <Box className={styles.cityAndAiroportBtns}>
              <CustomButton
                btnType='button'
                variant='outlined'
                onClick={closeModal}
              >
                Cancel
              </CustomButton>
              <CustomButton
                btnType='submit'
                customClass={styles.customButton}
                disabled={isSubmitting}
              >
                Save
              </CustomButton>
            </Box>
            {isSuccess && <Typography variant='h12' sx={{ color: '#208B64' }}>
             Budget Preferences updated successfully.
            </Typography>}
            {resErrors && resErrors.map((error, index) => (
              <Typography key={index} variant='h12' sx={{ color: '#C8102E' }}>
                {error.detail}
              </Typography>
            ))}
          </Form>)}
      </Formik>
    </Box>
  )
}

export default BudgetPreferences;
